import { RequestDataIds } from '../constants/ABA';

export interface StringMap<T> {
  [key: string]: T;
}

export enum Product {
  instant = 'instant',
  live = 'live',
  slots = 'slots',
  sports = 'sports',
  tvgames = 'tvgames',
  vs = 'vs',
}

type ProductInnerBalance = {
  amount: number;
};

type ProductBalance = {
  amount: number;
  available: number;
  innerBalances: {
    bonus: ProductInnerBalance;
    locked: ProductInnerBalance;
  };
};

type ProductBalances = Record<Product, ProductBalance>;

type UserBalances = {
  available: number;
  pendingBet: number;
  pendingWithdrawal: number;
  total: number;
  productBalances: ProductBalances;
};

type UserCurrency = {
  brandId: string;
  id: number;
  isRestricted: boolean;
  name: string;
};

type UserAccount = {
  number: string;
  brand: string;
  country: {
    id: number; // 804,
    iso2: string; // "UA",
    iso3: string; // "UKR",
    name: string; // "Ukraine",
    telephoneDialingPrefix: string; // "380"
  };
  email?: string;
  phone: string;
  dateOfBirthday?: string;
  city?: string;
  firstName: string;
  lastName: string;
  currency: UserCurrency;
  currencyRate: number;
  balances: UserBalances;
  restOfSum: number;
  restOfNCalc: number;
  restOfNPay: number;
  evaBonusBalance: number;
  evaLockedBalance: number;
  sportBonusBalance: number;
  isBlocked: boolean;
  isPokerPlayer: boolean;
  status: number;
  isEmailConfirmed: boolean;
  lastIp: string;
  lastLoginDateTime: string;
  lastLoginCountryIso2?: string;
  bonus4Express: {
    step: number;
    minCoef: number;
    minCount: number;
    maxCount: number;
  };
  address2: string;
  isDepositDisabled: boolean;
  isWithdrawalDisabledCy: boolean;
  isFirstDeposit: boolean;
  isShortRegistration: boolean;
  isShortRegistrationCompleted: boolean;
  isPhoneConfirmed: boolean;
  isTwoFactorAuthEnabled: boolean;
  isProfileCompleted: boolean;
  isVerified: boolean;
  contactKey: string;
  paymentHub: string;
  selectedLanguage?: string;
  regions: {
    region: string;
    macroRegion: string;
    timestamp: number;
  };
};

export interface State {
  [RequestDataIds.RenderContainer]: string;
  [RequestDataIds.Language]: string;
  [RequestDataIds.BaseUrl]: string;
  [RequestDataIds.Brand]: string;
  [RequestDataIds.Channel]: string;
  [RequestDataIds.ProxyPrefix]: string;
  [RequestDataIds.UserToken]: string;
  [RequestDataIds.UserData]: UserAccount;
  [RequestDataIds.ClientId]: string;
  [RequestDataIds.Platform]: string;
  [RequestDataIds.DepositUrl]: string;
  [RequestDataIds.WithdrawalUrl]: string;
  [RequestDataIds.LayoutDimensions]: {
    top: string;
    left: string;
    right: string;
    bottom: string;
  };
  [RequestDataIds.AssetsManifest]: {};
  [RequestDataIds.AmsSegments]: number[];
  [RequestDataIds.Theme]: string;
  [RequestDataIds.CrossDomainClickStreamId]: string;
  [RequestDataIds.Operator]: string;
  [RequestDataIds.BrandHash]: string;
  [RequestDataIds.ApplicationId]: string;
  [RequestDataIds.APIKey]: string;
}
